<template>
	<div class="col" align-x="center" gutter="35">
		<h1 class="color-black-gray1">忘記密碼</h1>
		<el-form :model="ruleForm" :rules="rules" ref="forgetPasswordForm" status-icon>
			<el-form-item prop="email">
				<el-input v-model="ruleForm.email" @keydown.native.enter.prevent="fogotPasswordSubmit" placeholder="請輸入您註冊的帳號"></el-input>
			</el-form-item>
			<el-form-item>
				<el-button @click="fogotPasswordSubmit" type="info">確認</el-button>
			</el-form-item>
		</el-form>

		<el-dialog title="忘記密碼" center :visible.sync="dialogVisible" @close="$router.push({name: 'Login'})">
			<p style="text-align:center;">請至您的信箱查看重置密碼確認信
				<br />按照信件步驟，重置密碼
			</p>
		</el-dialog>
	</div>
</template>

<script>
import { mapActions } from "vuex";

export default {
	data() {
		return {
			dialogVisible: false,
			ruleForm: {},
			rules: {
				email: [
					{ required: true, message: "請輸入電子信箱", trigger: "blur" },
					{ type: "email", message: "請輸入正確信箱格式", trigger: "blur" }
				]
			}
		};
	},
	methods: {
		...mapActions("user", ["forgetPassword"]),
		fogotPasswordSubmit() {
			this.$refs["forgetPasswordForm"].validate(async valid => {
				let data = {
					account: this.ruleForm.email
				};
				try {
					await this.forgetPassword(data);
					this.dialogVisible = true;
				} catch (e) {
					this.$message.error(e);
					console.log(e);
				}
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.el-form {
	width: 360px;
}
.el-input {
	width: 100%;
}
.el-button {
	width: 100%;
}
p.center {
	text-align: center;
}
</style>
